<div class="flex flex-col pt-8">
  <pin-button buttonId="funds-placed-button" buttonStyle="menu" customClass="menu-button" redirectUrl="/where-can-my-funds-be-placed" (buttonClick)="closeMenu()">
    WHERE CAN MY FUNDS BE PLACED?
  </pin-button>
  @if (hasCustomerLevelAccess && !isSsoUser) {
    <pin-button buttonId="account-access-button" buttonStyle="menu" customClass="menu-button" redirectUrl="/manage-access" (buttonClick)="closeMenu()">
      MANAGE ACCOUNT ACCESS
    </pin-button>
  }
  <mat-divider [vertical]="false" class="mx-8! my-4!"></mat-divider>
  @if (!isSsoUser) {
    <pin-button buttonId="profile-settings-button" buttonStyle="menu" customClass="menu-button" redirectUrl="{{ internalRoutes.MY_PROFILE }}" (buttonClick)="closeMenu()">
      MY PROFILE SETTINGS
    </pin-button>
  }
  <pin-button class="btn-logout" buttonStyle="menu" customClass="menu-button" redirectUrl="/logout" fragment="ssoLogout" (buttonClick)="closeMenu()">
    <div class="flex items-center">
      <mat-icon aria-hidden="true" class="md-20">logout</mat-icon>LOG OUT
    </div>
  </pin-button>
</div>
